import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'formly-input',
  template: `
    <input
      [type]="to.type || 'text'"
      [formControl]="formControl"
      [formlyAttributes]="field"
      class="input input-bordered w-full focus:outline-none"
    />
  `,
  imports: [ReactiveFormsModule, FormlyModule],
})
export class FormlyInputComponent extends FieldType {
  override get formControl(): FormControl {
    return super.formControl as FormControl;
  }
}
